<template>
    <div>
        <alert-modal :modalId="alertId"
                     :controller="controller.alertModal"
                     v-if="controller.alertModal != null"
        ></alert-modal>
        <loading-modal
                    :modalId="loadingId"
                    :controller="controller.loadingModal"
                    v-if="controller.loadingModal != null"
        ></loading-modal>
        <confirm-modal
                    :modalId="confirmId"
                    :controller="controller.confirmModal"
                    v-if="controller.confirmModal != null"
        ></confirm-modal>
        <RegisterSuccessModal
                    :modalId="registerSuccessId"
                    :controller="controller.registerSuccessModal"
                    v-if="controller.registerSuccessModal != null"
        ></RegisterSuccessModal>
        <TermsModal
                :modalId="termsId"
                :controller="controller.termsModal"
                v-if="controller.termsModal != null"
        ></TermsModal>
    </div>
</template>
<script>
import AlertModal from "./AlertModal.vue";
import LoadingModal from "./LoadingModal.vue";
import ConfirmModal from "./ConfirmModal.vue";
import RegisterSuccessModal from './RegisterSuccessModal.vue';
import TermsModal from './TermsModal.vue'
/**
 * @property {ModalController} controller (required) /components/Modal/Controller/ModalController.js
 */
export default {
    name: "ModalMaster",
    props: {
        // busModal: Object,
        controller: Object,
    },
    components: {
        AlertModal,
        LoadingModal,
        ConfirmModal,
        RegisterSuccessModal,
        TermsModal,
    },
    data: function() {
        return {
            randomNum: Math.floor(Math.random() * 100000) + '',
            alertId: '',
            loadingId: '',
            confirmId: '',
            termsId: '',
        };
    },
    created: function() {
        this.alertId = 'alert-modal-' + this.randomNum;
        this.loadingId = 'loading-modal-' + this.randomNum;
        this.confirmId = 'confirm-modal-' + this.randomNum;
        this.registerSuccessId = 'register-success-modal-' + this.randomNum;
        this.termsId = 'terms-modal-' + this.randomNum;
    },
    mounted: function() {
        // this.alertModal.show();
    },
}
</script>
